var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27285 11.9999H1.63638C0.734191 11.9999 0 11.2657 0 10.3635V2.72708C0 1.82489 0.734191 1.0907 1.63638 1.0907H6.00008C6.30117 1.0907 6.54554 1.33452 6.54554 1.63616C6.54554 1.9378 6.30117 2.18162 6.00008 2.18162H1.63638C1.33584 2.18162 1.09092 2.42599 1.09092 2.72708V10.3635C1.09092 10.6646 1.33584 10.909 1.63638 10.909H9.27285C9.57339 10.909 9.81831 10.6646 9.81831 10.3635V5.99985C9.81831 5.69821 10.0627 5.45439 10.3638 5.45439C10.6649 5.45439 10.9092 5.69821 10.9092 5.99985V10.3635C10.9092 11.2657 10.175 11.9999 9.27285 11.9999Z",
    fill: "#FC686F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4539 -0.000366211H8.18111C7.96074 -0.000366211 7.76165 0.132181 7.6771 0.336183C7.59256 0.540186 7.63946 0.774734 7.79547 0.930736L9.04621 2.18148L5.06816 6.15953C4.85488 6.3728 4.85488 6.71754 5.06816 6.93081C5.17452 7.03718 5.31416 7.09063 5.4538 7.09063C5.59344 7.09063 5.73308 7.03718 5.83944 6.93081L9.81749 2.95276L11.0682 4.2035C11.1724 4.30769 11.3121 4.36332 11.4539 4.36332C11.5242 4.36332 11.5952 4.35023 11.6628 4.32187C11.8662 4.23787 11.9993 4.03823 11.9993 3.81786V0.545095C11.9993 0.243455 11.755 -0.000366211 11.4539 -0.000366211Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.e4f078bcf67c9d79700f90168b6e55e4.svg";
export { ForwardRef as ReactComponent };